module.exports = __webpack_public_path__ + "img/sales.eaa40b5f.svg";